module.exports = __webpack_public_path__ + "static/media/privacypolicy.f81310fa.png";